
import { Record, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { list_type, option_type, string_type, record_type, class_type, union_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { tryFind, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";

/**
 * Why a moderator hid content. A code only: never a copy of the content.
 */
export class ModerationReason extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Illegal", "Harassment", "HateSpeech", "SexualContent", "ViolenceOrThreats", "PersonalInformation", "SpamOrScam", "OtherPolicyViolation"];
    }
}

export function ModerationReason_$reflection() {
    return union_type("Shared.ModerationReason", [], ModerationReason, () => [[], [], [], [], [], [], [], []]);
}

export const ModerationReasonModule_all = ofArray([new ModerationReason(0, []), new ModerationReason(1, []), new ModerationReason(2, []), new ModerationReason(3, []), new ModerationReason(4, []), new ModerationReason(5, []), new ModerationReason(6, []), new ModerationReason(7, [])]);

export function ModerationReasonModule_toWireString(reason) {
    switch (reason.tag) {
        case 1:
            return "harassment";
        case 2:
            return "hate-speech";
        case 3:
            return "sexual-content";
        case 4:
            return "violence-or-threats";
        case 5:
            return "personal-information";
        case 6:
            return "spam-or-scam";
        case 7:
            return "other-policy-violation";
        default:
            return "illegal";
    }
}

export function ModerationReasonModule_tryParse(value) {
    return tryFind((reason) => (ModerationReasonModule_toWireString(reason) === value), ModerationReasonModule_all);
}

export function ModerationReasonModule_label(reason) {
    switch (reason.tag) {
        case 1:
            return "Harassment or bullying";
        case 2:
            return "Hate speech";
        case 3:
            return "Sexual content";
        case 4:
            return "Violence or threats";
        case 5:
            return "Personal information";
        case 6:
            return "Spam or scam";
        case 7:
            return "Other policy violation";
        default:
            return "Illegal content";
    }
}

/**
 * Who hid a piece of content, when, and why.
 */
export class HiddenContentInfo extends Record {
    constructor(Reason, ModeratorId, HiddenAt) {
        super();
        this.Reason = Reason;
        this.ModeratorId = ModeratorId;
        this.HiddenAt = HiddenAt;
    }
}

export function HiddenContentInfo_$reflection() {
    return record_type("Shared.HiddenContentInfo", [], HiddenContentInfo, () => [["Reason", ModerationReason_$reflection()], ["ModeratorId", class_type("System.Guid")], ["HiddenAt", class_type("System.DateTimeOffset")]]);
}

/**
 * Who suspended an account, when, and why. A code only: never a copy of any content.
 */
export class AccountSuspensionInfo extends Record {
    constructor(Reason, ModeratorId, SuspendedAt) {
        super();
        this.Reason = Reason;
        this.ModeratorId = ModeratorId;
        this.SuspendedAt = SuspendedAt;
    }
}

export function AccountSuspensionInfo_$reflection() {
    return record_type("Shared.AccountSuspensionInfo", [], AccountSuspensionInfo, () => [["Reason", ModerationReason_$reflection()], ["ModeratorId", class_type("System.Guid")], ["SuspendedAt", class_type("System.DateTimeOffset")]]);
}

export class SuspendAccountRequest extends Record {
    constructor(UserId, Reason) {
        super();
        this.UserId = UserId;
        this.Reason = Reason;
    }
}

export function SuspendAccountRequest_$reflection() {
    return record_type("Shared.SuspendAccountRequest", [], SuspendAccountRequest, () => [["UserId", class_type("System.Guid")], ["Reason", ModerationReason_$reflection()]]);
}

export const AccountSuspension_suspendedMessage = "Your account is suspended, so you can\'t make changes. Contact support if you think this is a mistake.";

export class HiddenDailyLogInfo extends Record {
    constructor(Date$, Hidden) {
        super();
        this.Date = Date$;
        this.Hidden = Hidden;
    }
}

export function HiddenDailyLogInfo_$reflection() {
    return record_type("Shared.HiddenDailyLogInfo", [], HiddenDailyLogInfo, () => [["Date", class_type("System.DateOnly")], ["Hidden", HiddenContentInfo_$reflection()]]);
}

/**
 * A challenge's cover as moderators see it: the rendition URL and who hid it, if anyone.
 */
export class ModeratedCoverImage extends Record {
    constructor(Url, Hidden) {
        super();
        this.Url = Url;
        this.Hidden = Hidden;
    }
}

export function ModeratedCoverImage_$reflection() {
    return record_type("Shared.ModeratedCoverImage", [], ModeratedCoverImage, () => [["Url", string_type], ["Hidden", option_type(HiddenContentInfo_$reflection())]]);
}

export class ModerationStatusResponse extends Record {
    constructor(ChallengeId, Challenge, HiddenDailyLogs, CoverImage, HostUserId, HostSuspension) {
        super();
        this.ChallengeId = ChallengeId;
        this.Challenge = Challenge;
        this.HiddenDailyLogs = HiddenDailyLogs;
        this.CoverImage = CoverImage;
        this.HostUserId = HostUserId;
        this.HostSuspension = HostSuspension;
    }
}

export function ModerationStatusResponse_$reflection() {
    return record_type("Shared.ModerationStatusResponse", [], ModerationStatusResponse, () => [["ChallengeId", class_type("System.Guid")], ["Challenge", option_type(HiddenContentInfo_$reflection())], ["HiddenDailyLogs", list_type(HiddenDailyLogInfo_$reflection())], ["CoverImage", option_type(ModeratedCoverImage_$reflection())], ["HostUserId", class_type("System.Guid")], ["HostSuspension", option_type(AccountSuspensionInfo_$reflection())]]);
}

export class HideChallengeRequest extends Record {
    constructor(ChallengeId, Reason) {
        super();
        this.ChallengeId = ChallengeId;
        this.Reason = Reason;
    }
}

export function HideChallengeRequest_$reflection() {
    return record_type("Shared.HideChallengeRequest", [], HideChallengeRequest, () => [["ChallengeId", class_type("System.Guid")], ["Reason", ModerationReason_$reflection()]]);
}

export class HideDailyLogRequest extends Record {
    constructor(ChallengeId, Date$, Reason) {
        super();
        this.ChallengeId = ChallengeId;
        this.Date = Date$;
        this.Reason = Reason;
    }
}

export function HideDailyLogRequest_$reflection() {
    return record_type("Shared.HideDailyLogRequest", [], HideDailyLogRequest, () => [["ChallengeId", class_type("System.Guid")], ["Date", class_type("System.DateOnly")], ["Reason", ModerationReason_$reflection()]]);
}

export class RestoreDailyLogRequest extends Record {
    constructor(ChallengeId, Date$) {
        super();
        this.ChallengeId = ChallengeId;
        this.Date = Date$;
    }
}

export function RestoreDailyLogRequest_$reflection() {
    return record_type("Shared.RestoreDailyLogRequest", [], RestoreDailyLogRequest, () => [["ChallengeId", class_type("System.Guid")], ["Date", class_type("System.DateOnly")]]);
}

//# sourceMappingURL=Moderation.js.map
